<!-- 企业认证 -->
<template>
	<div class="vc-wrapper">
		<div class="vc-title">
			当前认证公司:&nbsp;&nbsp;<span class="vc-company" @click="open">{{form1.company_name}}</span>
			<img src="./assets/img/edit.png" class="vc-edit" @click="open" />
		</div>

		<div class="vc-card">
			<div class="vc-card-left">
				<div class="vc-upload-dropzone" @click="triggerFileSelect">
					<div class="vc-upload-title">上传公司营业执照</div>
					<div class="vc-upload-icon"></div>
					<div class="vc-upload-sub">点击或拖拽文件到此处上传</div>
					<div class="vc-upload-tip">支持JPG、PNG、PDF格式，大小不超过10MB</div>
					<input ref="fileInput" type="file" accept="image/*" style="display:none" @change="handleFileChange" />
				</div>
			</div>
			<div class="vc-card-right">
				<ul class="vc-tips">
					<li>拍摄/上传与所填公司<span class="highlight">全称一致</span>的营业执照</li>
					<li>上传<span class="highlight">最新下发</span>的营业执照</li>
					<li>营业执照信息与公章<span class="highlight">清晰可辨</span></li>
					<li>如上传复印件/彩印请<span class="highlight">加盖公司公章</span></li>
				</ul>
			</div>
		</div>

		<div class="vc-example">
			<span class="vc-example-title">合格样式</span>
			<img src="./assets/img/lisence.png" alt="合格样式" class="vc-example-img">
		</div>
		<div class="vc-actions">
			<el-button class="vc-btn-outline" type="primary" @click="goBack">更换其他验证方式</el-button>
			<el-button class="vc-btn-primary" type="primary" @click="handleNext">开始验证</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification,
		getEmail,
		getEmailbox
	} from '@/api/email'
 	import { lxUploadFile, yyzzUploadFile } from '@/api/upload'
	import {   bindCompanyInfo } from '@/api/verify'
	export default {
		data() {
			const validateIdCard = (rule, value, callback) => {
				const reg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				if (!value) {
					return callback(new Error("请输入邮箱地址"));
				} else if (!reg.test(value)) {
					return callback(new Error("请输入正确的邮箱地址"));
				} else {
					callback();
				}
			};

			return {
				form: {},
				form1: {
					company_name: "",
					email: "",
					verificationCode: "",
				},
				uploadedFile: null,
				uploadedImageUrl: '',
				isUploading: false,
				// 验证规则配置
				rules: {
					company_name: [{
							required: true,
							message: "请输入公司邮箱",
							trigger: "blur"
						},
						{
							min: 2,
							max: 50,
							message: "公司名称长度在2-50个字符之间",
							trigger: "blur",
						},
					],
					email: [{
				required: true,
				validator: validateIdCard,
				trigger: "blur"
			}],
			verificationCode: [{
				required: true,
				message: "请输入验证码",
				trigger: "blur"
			}],
		}
			};
		},
		created() {
			this.form = JSON.parse(this.$route.query.form)
			this.form1.company_name = this.form.company_name
		},
		methods: {
			triggerFileSelect() {
				this.$refs.fileInput && this.$refs.fileInput.click();
			},
			handleFileChange(e) {
				const file = e.target.files && e.target.files[0];
				if (!file) return;
				if (!file.type.startsWith('image/')) {
					this.$message.error('请选择图片文件');
					return;
				}
				// 5MB 限制
				if (file.size > 5 * 1024 * 1024) {
					this.$message.error('文件大小不能超过5MB');
					return;
				}
				this.uploadedFile = file;
				this.uploadFile(file);
			},
			async uploadFile(file) {
				try {
					this.isUploading = true;
					const formData = new FormData();
					formData.append('file', file);
					const response = await lxUploadFile(formData);
					if (response && response.data && response.data.data && response.data.data.url) {
						this.uploadedImageUrl = response.data.data.url;
						this.$message.success('文件上传成功');
					} else {
						throw new Error('上传失败');
					}
				} catch (err) {
					this.$message.error('文件上传失败，请重试');
					this.uploadedFile = null;
					this.uploadedImageUrl = '';
				} finally {
					this.isUploading = false;
				}
			},
			async verifyBusinessLicense() {
				const params = {
					detect_direction: false,
					image_url: this.uploadedImageUrl,
					probability: false
				};
				try {
					const {data} = await yyzzUploadFile(params);
					if (data && data.code == 1) {
						if(data.data.unit_name != this.form1.company_name) {
							this.$message.error('营业执照验证失败');
							return;
						}
						bindCompanyInfo({ company_name: this.form1.company_name }).then(res => {
							if (res.data.code === 1) {
								this.$message.success('营业执照验证成功');
								localStorage.removeItem('companyVerifyInfo');
								this.$router.push({
									path: '/position',
								});
								
							}else {
								this.$message({
									type: 'error',
									message: res.data.msg || '营业执照验证失败'
								});
							}
						});
						
					} else {
						this.$message.error('营业执照验证失败');
					}
				} catch (e) {
					this.$message.error('营业执照验证失败');
				}
			},
			open() {
				this.$prompt('请输入公司名称', '编辑', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(({
					value
				}) => {
					getCertification({
						company_name: value,
					}).then(async res => {
						if (res.data.code === 1) {
							this.form1.company_name = res.data.data.company_name
							this.form.company_name = res.data.data.company_name
						} else {
							this.form1.company_name = this.form.company_name
							this.$message({
								type: 'info',
								message: '您输入的公司不存在！'
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消修改'
					});
				});
			},
			loginEmail() {
				getEmail({
					email: this.form1.email,
				}).then(async response => {
					if (response.data.code === 1) {
						this.$message({
							type: 'success',
							message: '验证码发送成功'
						});
					}
				})
			},
			goBack() {
				this.$confirm('确认更换其他验证方式吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.push({
						path: '/verifyCompany/businessVerificationFunc',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			handleNext() {
				if (!this.uploadedImageUrl) {
					this.$message.warning('请先上传营业执照');
					return;
				}
				this.verifyBusinessLicense();
			},
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 18px;
		font-size: large;
		background-image: linear-gradient(90deg, rgba(126, 180, 235, 1) 0, rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-left: 20px;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.submitButton {
		width: 180px;
		height: 50px;
		border-radius: 18px;
		background-image: linear-gradient(90deg,
				rgba(126, 180, 235, 1) 0,
				rgba(177, 110, 249, 1) 100%);
		color: white;
		margin-top: 20px;
		font-size: x-large;
		cursor: pointer;
	}

	/* 自定义表单样式 - 字体变大加粗 */
	::v-deep .custom-form {
		/* 调整整体表单的字体大小 */
		font-size: 18px;
		margin-top: 10px;
	}

	/* 表单项标签样式 */
	::v-deep .custom-form .el-form-item__label {
		font-weight: bold;
		/* 标签加粗 */
		font-size: 18px;
		/* 标签字体稍大于输入框 */
		color: #333;
		/* 加深标签颜色 */
	}

	/* 输入框内容样式 */
	::v-deep .custom-form .el-input__inner {
		font-size: 18px;
		/* 输入框字体大小 */
		padding: 10px 15px;
		/* 加大输入框内边距，让整体更大气 */
	}
</style>